import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";

import { AccountContext } from "context/account";
import api from "services/api";
import toast from "react-hot-toast";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Avatar from "@mui/material/Avatar";
import { Tag } from "antd";

const NewBlogCard = ({ index, blog, ...rest }) => {
  const [isHover, setIsHover] = useState(false);

  const account = useContext(AccountContext);
  const navigate = useNavigate();

  let labels = blog?.labels || [];
  labels = labels.slice(0, 6);

  return (
    <Card
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      sx={{
        borderRadius: 2,
        boxShadow: ({ boxShadows: { lg } }) => (isHover ? lg : "none"),
      }}
    >
      <div>
        <SuiBox
          onClick={(e) => {
            navigate(`/social/blog?viewblogid=${blog.id}`);
          }}
          sx={{
            cursor: "pointer",
            backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.secondary.state, 0.1),
                rgba(gradients.secondary.state, 0.1)
              )}`,

            overflow: "hidden",
            position: "relative",
            display: "flex",
            minWidth: 0,
            width: "100%",
            ...rest?.sx,
          }}
          className="post-card-parent"
        >
          <ImageCardWrapper
            data={{ url: blog?.mainimg, type: "image/*", name: "blog" }}
            height={234}
            width={300}
            draggable={false}
            {...rest}
          />
          <SuiBox sx={{ position: "absolute", bottom: 2, left: 2 }}>
            {labels.map((label) => {
              return (
                <Tag color="gold" style={{ marginBottom: 2 }}>
                  {label}
                </Tag>
              );
            })}
          </SuiBox>
          <SuiBox className="post-card-overlay">
            <SuiBox display="flex" alignItems="center" gap={1}>
              <SuiTypography
                variant="body1"
                textTransform="none"
                color="white"
                sx={{
                  fontWeight: "bold",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical",
                }}
              >
                {blog?.title}
              </SuiTypography>{" "}
            </SuiBox>
          </SuiBox>
        </SuiBox>
      </div>
      <SuiBox sx={{ my: 0.5 }}>
        <SuiTypography
          className="grow ml-3 mr-3 mt-1"
          variant="body1"
          fontWeight="regular"
          color="text"
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "2",
            WebkitBoxOrient: "vertical",
            minHeight: 40,
            lineHeight: 1.2,
          }}
        >
          {blog.summary}
        </SuiTypography>
      </SuiBox>
      <SuiBox sx={{ my: 0.5, px: 1 }}>
        <SuiBox display="flex" justifyContent="space-between" alignItems="center">
          <SuiBox display="flex" alignItems="center" gap={0.5} sx={{ cursor: "pointer" }}>
            <Avatar src={blog.metadata?.avatar} sx={{ width: 36, height: 36, cursor: "pointer" }} />
            <SuiBox>
              <SuiTypography
                variant="body2"
                color="dark"
                sx={{
                  fontWeight: "bold",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "1",
                  WebkitBoxOrient: "vertical",
                  wordBreak: "break-all",
                  cursor: "pointer",
                }}
              >
                {blog?.username}
              </SuiTypography>
              <SuiTypography
                variant="body2"
                textTransform="none"
                color="text"
                sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "1",
                  WebkitBoxOrient: "vertical",
                }}
              >
                {new Date(blog.timestamp).toDateString()}
              </SuiTypography>{" "}
            </SuiBox>
          </SuiBox>
        </SuiBox>
      </SuiBox>
    </Card>
  );
};
export default NewBlogCard;
